import {
  borderNames,
  borderDesc,
  titles,
  subtitles,
  noticeOtherTexts,
  noticeName,
  noticeDesc
} from "./texts-common-sections";
import {SmallTexts} from "../enums/small-texts";

const urlImages = "/assets/images/modules/section_4/";

export const Section4 = {
  ExplanationTexts: {
    title_expl01: titles.titleCasComptoir1,
    text_expl01: "<span class='text-bubble-step color-red fw-bold text-uppercase'>Comment accompagner Mme&nbsp;F. à" +
      " l’officine pour les suites de sa brûlure à la jambe&nbsp;?</span>",
    image_expl01: urlImages + "1_Compo-arriere-plan-2.png",
    title_expl02: titles.titleCasComptoir1,
    text_expl02: "<span class='mt-4 d-block text-bubble-step color-red fw-bold text-uppercase'>La brûlure se situe sur la partie basse de" +
      " ma jambe gauche.<br/>Pouvez-vous regarder, je ne sais pas vous expliquer&nbsp;?</span>",
    image_expl02: urlImages + "Visuel_Discussion_patiente_pharmacien.png",
    title_expl03: titles.titleCasComptoir1,
    text_expl03: "<span class='mt-4 d-block fw-bold'><span class='d-block big-text'>" + subtitles.subtitleObservationPlaie + "</span>" +
      "<span class='d-block mt-3 color-green text-uppercase'>Vous vous apercevez que le capot de" +
      " la phlyctène<sup>*</sup> a été arraché. Il s’agit sûrement de ce dont vous parlait votre patiente concernant" +
      " la partie de plaie restée collée aux compresses.</span>" +
      "</span>",
    image_expl03: urlImages + "02secPA_bru_01.jpg",
    asterisks_expl03: [
      "<span class='fw-bold'>Phlyctène</span>&nbsp;: une phlyctène est un soulèvement de l'épiderme<sup>1</sup> créant" +
      " une cavité localisée qui se remplit de liquide séreux et translucide (phlyctène séreuse), ou d’éléments" +
      " sanguins, coagulés ou non (phlyctène hématique). Une phlyctène est généralement douloureuse.<sup>2</sup>"
    ],
    title_expl04: titles.titleCasComptoir1,
    image_expl04: urlImages + "02secPA_bru_01.jpg",
    text_expl04: "<span class='mt-4 d-block'><span class='text-uppercase color-green fw-bold'>" + subtitles.subtitleObservationPlaie + "</span> <span class='d-block mt-3 fst-italic small-text'>Cliquez sur les 5 points pour en savoir plus.</span></span>",
    list_buttons_expl04: [
      {
        title: "",
        content: [
          {
            text: "Les berges de la plaie sont en voie d’épidermisation, peau périlésionnelle altérée au niveau supérieur."
          }
        ],
        position: {
          top: "19%",
          left: "38%"
        }
      },
      {
        title: "",
        content: [
          {
            text: "Pas de signes infectieux"
          }
        ],
        position: {
          top: "45%",
          left: "44%"
        }
      },
      {
        title: "",
        content: [
          {
            text: "Absence de macération, écoulement modéré séro-sanglant <span class='fst-italic'>(selon les dires" +
              " de la jeune femme)</span>"
          }
        ],
        position: {
          top: "66%",
          left: "61%"
        }
      },
      {
        title: "",
        content: [
          {
            text: "Absence de fibrine et de nécrose"
          }
        ],
        position: {
          top: "48%",
          left: "70%"
        }
      },
      {
        title: "",
        content: [
          {
            text: "Présence d’environ 30% de tissu de granulation et de 70% de tissu d’épidermisation à consolider."
          }
        ],
        position: {
          top: "30%",
          left: "52%"
        }
      },
    ],
    title_expl05: titles.titleCasComptoir1,
    image_expl05: urlImages + "02secPA_bru_01.jpg",
    text_expl05: "<span class='d-block color-red big-text'>Voici la synthèse de vos observations</span>" +
      "<span class='d-block small mt-3 fw-bold'>Caractéristiques de la patiente&nbsp;:</span>" +
      "<ul class='small'>" +
      "<li>Femme, jeune</li>" +
      "<li>Absence de comorbidités particulières (recueilli à l’interrogatoire)</li>" +
      "</ul>" +
      "<span class='d-block small mt-3 fw-bold'>Type de plaie & localisation&nbsp;:</span>" +
      "<ul class='small'>" +
      "<li>Brûlure&nbsp;; Partie basse de la jambe gauche</li>" +
      "<li>Absence d’odeur</li>" +
      "<li>Non douloureuse</li>" +
      "</ul>" +
      "<span class='d-block small mt-3 fw-bold'>Aspect de la plaie&nbsp;:</span>" +
      "<ul class='small'>" +
      "<li>Phase avancée de cicatrisation&nbsp;: absence de fibrine et de nécrose, 30 % de bourgeonnement et 70 %" +
      " d’épidermisation</li>" +
      "<li>Peu profonde</li>" +
      "<li>Légèrement à modérément exsudative</li>" +
      "<li>Absence de macération</li>" +
      "<li>Absence de signes infectieux</li>" +
      "<li>Peau périlésionnelle altérée</li>" +
      "</ul>",
    title_expl06: titles.titleCasComptoir1,
    text_expl06: "<span class='d-block text-start'>" +
      "<span class='d-block text-uppercase big-text color-green'>" + subtitles.subtitleChoixPansement + "</span>" +
      "<span class='d-block my-3 fw-bold'>Caractéristiques des pansements hydrocellulaires<sup>1,2</sup></span>" +
      "<ul class='mb-5'>" +
      "<li>Capacité d’absorption de longue durée (suivant la composition)</li>" +
      "<li>Formes adaptées aux différentes localisations</li>" +
      "<li>Protègent les bourgeons</li>" +
      "<li>Ne se délitent pas au contact de la plaie</li>" +
      "<li>Sont contre-indiqués pour les plaies infectées</li>" +
      "</ul>",
    list_buttons_expl06: [
      {
        group: "",
        title: "Voir pourquoi exclure les autres types de pansements pour la plaie de <span class='text-nowrap'>Mme" +
          " F.</span>",
        content: [
          {
            title: "Caractéristiques des pansements hydrofibre, alginate et hydrogel<sup>1,2</sup>",
            image: urlImages + "04sec06e_modal_img.png",
            small_texts: {
              1: SmallTexts.Has,
              2: SmallTexts.Chru,
            }
          }
        ],
      }
    ],
    title_expl07: titles.titleCasComptoir1,
    text_expl07: "<span class='d-block text-start'>" +
      "<span class='d-block text-uppercase big-text color-green'>" + subtitles.subtitleChoixPansement + "</span>" +
      "<span class='d-block small mt-3 color-red'>Vous vous orientez vers les gammes de " +
      "<span class='fw-bold'>pansements hydrocellulaires siliconés</span><sup>#</sup> proposées par " +
      "<span class='fw-bold'>L&R</span>.</span>" +
      "<span class='d-block small mt-3'>Différentes références sont disponibles suivant la <span" +
      " class='fw-bold'>quantité d’exsudat</span>.</span>" +
      "<img class='mt-3' src='" + urlImages + "03sec06e_img.png" + "' />" +
      "</span>",
    annexes_expl07: [
      "<span class='small-text d-block text-start'># Sauf pour les pansements de la gamme" +
      " <span class='fw-bold'>Vliwasorb<sup>®</sup> Pro</span> qui ne sont pas siliconés&nbsp;;</span>",
      "<span class='small-text d-block text-start'>" +
      "*&nbsp;<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + "&nbsp;; " +
      "**&nbsp;<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder + "&nbsp;; " +
      "***&nbsp;<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + "&nbsp;; " +
      "****&nbsp;<span class='fw-bold'>" + borderNames.heel + "</span>&nbsp;: " + borderDesc.heel + "</span>" +
      "</span>"
    ],
    title_expl08: titles.titleCasComptoir1,
    text_expl08: "<span class='d-block text-start'>" +
      "<span class='d-block text-uppercase big-text color-green'>" + subtitles.subtitleChoixPansement + "</span>" +
      "<span class='d-block small mt-3 color-red'>Vous vous orientez vers la gamme de " +
      "<span class='fw-bold'>pansements hydrocellulaires siliconés</span> proposée par " +
      "<span class='fw-bold'>L&R</span>&nbsp;: <span class='fw-bold'>Suprasorb<sup>®</sup> P sensitive</span></span>" +
      "<img class='mt-3' src='" + urlImages + "04sec08e_img.png" + "' />" +
      "</span>",
    annexes_expl08: [
      "<span class='small-text d-block text-start'>" +
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.heel + "</span>&nbsp;: " + borderDesc.heel + "</span>" +
      "</span>"
    ],
    title_expl09: titles.titleCasComptoir1,
    image_expl09: urlImages + "04sec09e_img.png",
    text_expl09: "<span class='d-block text-start'>" +
      "<span class='d-block text-uppercase big-text color-green'>Conclusion</span>" +
      "<span class='d-block mt-3'>En résumé, la jeune femme ne souffre " +
      "d’<span class='fw-bold'>aucune pathologie</span> et la plaie ne présente " +
      "<span class='fw-bold'>ni nécrose, ni fibrine, ni signe d’infection ou de macération</span>.</span>" +
      "<span class='d-block mt-3'>La plaie est faiblement à moyennement exsudative et la <span class='fw-bold'>peau" +
      " périlésionnelle est altérée</span>.</span>" +
      "<span class='d-block mt-3'><img src='" + urlImages + "04sec09e_img.png" + "' /></span>",
    annexes_expl09: [
      "<span class='d-block small mt-3'>Vous pouvez lui proposer un pansement hydrocellulaire siliconé" +
      " <span class='fst-italic'>Suprasorb<sup>®</sup> P sensitive border lite*</span>, adapté aux plaies <span" +
      " class='fw-bold'>faiblement à moyennement exsudatives</span>.<sup>1</sup></span>" +
      "<span class='d-block small mt-3'>Sa couche en silicone au contact de la plaie limitera l’adhérence à la plaie" +
      " et minimisera la douleur au retrait.<sup>2,3</sup></span>" +
      "<span class='d-block small mt-3'>Vous pouvez également lui conseiller d'aller voir son médecin ou infirmier" +
      " traitant avec cette recommandation. En effet, ce type de pansement a un coût qui peut dissuader votre" +
      " patiente. La prise en charge par l'assurance maladie est possible pour ce type de plaie.</span>",
    ],
    asterisks_expl09: [
      "border lite&nbsp;: extra mince avec bord auto-fixant"
    ],
    annexes_q05: [
      "<span class='small-text d-block text-start'>" +
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder + "&nbsp;; " +
      "</span>"
    ],
  },
  Responses: {
    title_correct_q01: "Vous avez raison&nbsp;!",
    title_not_correct_q01: "Pourquoi ne pas investiguer&nbsp;? Vous avez probablement des moyens d’agir&nbsp;!",
    text_q01:"En tant que professionnel de santé, vous aidez et conseillez vos patients au quotidien. Vous" +
      " disposez de plusieurs solutions pour la prise en charge des plaies à l’officine, il est intéressant" +
      " d’évaluer si vous pouvez intervenir, en proposant un pansement adapté par exemple.",
    // text_correct_q01: "En tant que professionnel de santé, vous aidez et conseillez vos patients au quotidien. Vous" +
    //   " disposez de plusieurs solutions pour la prise en charge des plaies à l’officine, il est intéressant" +
    //   " d’évaluer si vous pouvez intervenir, en proposant un pansement adapté par exemple.",
    // text_not_correct_q01: "Pourquoi ne pas investiguer, vous avez probablement des moyens d’agir&nbsp;!",
    image_q01: urlImages + "3_Compo-arriere-plan-2.png",
    title_correct_q02: "Bravo&nbsp;!<sup>1-3</sup>",
    title_not_correct_q02: "Pas exactement&nbsp;!",
    text_correct_q02: "Il faut toujours se demander si la personne est âgée (ici, elle ne l’est pas).",
    text_not_correct_q02: "Avant de proposer un pansement à votre patient(e), vous devez vous intéresser aux" +
      " potentielles comorbidités ainsi qu’à différentes caractéristiques d’une plaie.<sup>1-3</sup> De plus, il" +
      " faut toujours se demander si la personne est âgée (ici elle ne l'est pas). Enfin, connaître le modèle de la moto responsable de la brûlure ne vous avancera en rien dans votre analyse.",
    title_correct_q03: "Bravo&nbsp;! La plaie est presque en échec",
    title_not_correct_q03: "Vous pouvez recommander mieux",
    text_q03: "Face à cette plaie faiblement ou modérément exsudative, à l’étape de bourgeonnement/épidermisation," +
      " un <span class='fw-bold'>pansement hydrocellulaire</span> est un choix pertinent pour Mme&nbsp;F.",
    title_correct_q04: "Bien joué&nbsp;! Vous n’êtes plus qu’à un coup de l’échec et mat&nbsp;!",
    title_not_correct_q04: "Aïe, ce n’est pas le coup qui va forcer l’échec et mat&nbsp;!",
    text_q04: "La gamme Vliwasorb<sup>®</sup> est adaptée aux plaies moyennement à très fortement exsudatives. En" +
      " regard d’une plaie faiblement à modérément exsudative, c’est la gamme <span" +
      " class='fw-bold'>Suprasorb<sup>®</sup> P sensitive</span> qu’il vaut mieux choisir.",
    title_correct_q05: "Quelle maitrise&nbsp;!",
    title_not_correct_q05: "Votre conseil est bon, mais il ne s’agit pas du pansement le plus adapté.",
    text_q05: "Dans cette situation, c’est le <span class='fw-bold'>Suprasorb<sup>®</sup> P sensitive «&nbsp;border" +
      " lite&nbsp;»</span> qui convient le mieux.",
  },
  EndTexts: {
    title_end01: "Bravo, vous avez su répondre aux attentes de votre patiente et lui conseiller un pansement adapté" +
      " à sa plaie.",
    text_end01_p01: "Un 2<sup>ème</sup> cas comptoir sera mis à votre disposition prochainement.",
    image_end01: urlImages + "04sec01end_img.png",
    annexes_end01: [
      "<span class='fw-bold'>" + noticeName.SupraPSensitiveBorderMultisiteBorderSacrumHeel + "</span>" +
      noticeDesc.SupraPSensitiveBorderMultisiteBorderSacrumHeel + " <span class='fw-bold'>" + noticeName.SuprasorbPSensitiveNonBorder + "</span> " +
      noticeDesc.SuprasorbPSensitiveNonBorder,
      "<span class='fw-bold'>" + noticeName.SuprasorbPSensitiveBorderLiteMultisiteBorderLite + "</span> " +
      noticeDesc.SuprasorbPSensitiveBorderLiteMultisiteBorderLite,
      "<span class='fw-bold'>" + noticeName.VliwasorbSensitiveClasseIIb + "</span> " +
      noticeDesc.VliwasorbSensitiveClasseIIb + "<br/>" + noticeOtherTexts.DispositifsMedicaux,
      "<span class='d-block mt-2'></span>" +
      "<span class='fw-bold'>" + noticeName.VliwasorbProClasseIIb + "</span>&nbsp: " +
      noticeDesc.VliwasorbProClasseIIb,
      "<span class='fw-bold'>" + noticeName.VliwasorbAhesif + "</span>&nbsp: " +
      noticeDesc.VliwasorbAhesif + "<br/>" + noticeOtherTexts.DispositifsMedicauxClasseIIb,
      "<span class='d-block mt-2'></span>" +
      noticeOtherTexts.LireAttentivement,
    ]
  },
};
